<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <!-- Summary info -->
            <v-flex lg6 pa-0 pl-3 pt-3>
                <v-btn
                    :color="payauthority.Status | display_color(orderStatus)"
                    width="160px"
                    height="36px"
                    small
                    dark
                    depressed
                    outlined
                  >{{ customStatus }}</v-btn>
            </v-flex>
            <!-- Action buttons -->
            <v-flex lg6 pa-0 pr-3 pt-6>
                <v-layout row wrap justify-end>
                    <v-btn style="margin-right: 10px;" v-if="payauthority.Status == orderStatusEnum.cho_uy_quyen && payauthority.Type == 1 && (customerServiceRole || adminRole)" @click="confirmPayment" color="#a77800" dark>
                        Xác nhận ủy quyền
                    </v-btn>
                    <v-btn style="margin-right: 10px;" v-if="canEdit" @click="saveData" color="#a77800" dark>
                        Cập nhật
                    </v-btn>
                    <v-btn style="margin-right: 10px;" v-if="((payauthority.Type == 0 && payauthority.Status == orderStatusEnum.da_uy_quyen) || payauthority.Type == 1) && adminRole" @click="saveRefund" dark>
                        Hủy & Hoàn tiền
                    </v-btn>
                    <v-btn style="margin-right: 10px;" v-if="payauthority.Type == 0 && payauthority.OrderCodes.filter(o => !o.Cancelled).length && (payauthority.Status == orderStatusEnum.khieu_nai) && adminRole" @click="saveRefund" color="#a77800" dark>
                        Hủy lệnh & Hoàn tiền
                    </v-btn>
                    <v-btn style="margin-right: 10px;" v-if="payauthority.Status == orderStatusEnum.cho_bao_gia && adminRole" @click="waitAuthority" color="#646262" dark>
                        {{payauthority.Type == 0 ? 'Báo giá' : 'Cấp TKUQ'}}
                    </v-btn>
                    <v-btn style="margin-right: 10px;" v-if="payauthority.Status == orderStatusEnum.da_uy_quyen && adminRole" @click="completeOrder" color="#646262" dark>
                        Hoàn thành
                    </v-btn>
                    <v-btn style="margin-right: 10px;" v-if="(payauthority.Status == orderStatusEnum.cho_uy_quyen || payauthority.Status == orderStatusEnum.cho_bao_gia) && adminRole" @click="cancelOrder" dark>
                        Hủy
                    </v-btn>
                </v-layout>
            </v-flex>
            <v-flex lg6>
                <v-widget>
                    <div slot="widget-header-action">
                        <h4 class="pl-2 pr-3 font-weight-bold">{{payauthority.CreatedDate | display_date('DD-MM-YYYY HH:mm:ss') | capitalize}}</h4>
                    </div>
                    <div slot="widget-content" class="customer-info-box">
                        <v-card-text>
                            <v-layout row wrap pt-1>
                                <v-flex lg4 sm4>
                                    <v-card-title class="pa-0">Khách hàng</v-card-title>
                                </v-flex>
                                <v-flex lg8 sm8 pa-0>
                                    <div class="mt-4 account-toggle font-weight-bold text-red" @click="showCustomerDetail = !showCustomerDetail">{{customer.Username}} <span class="icon" :class="{'open':showCustomerDetail}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-down theme--light"></i></span></div>
                                </v-flex>
                            </v-layout>
                            <v-card class="mx-auto" outlined v-if="customerView && showCustomerDetail">
                                <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title class="mb-2"><a href="javascript:void(0)" class="font-weight-bold text-red" @click="gotoCustomerDetail(customer.ID)">{{customer.Username}}</a></v-list-item-title>
                                    <v-list-item-subtitle class="mb-1">Họ tên: {{customer.FirstName + ' ' + customer.LastName}}</v-list-item-subtitle>
                                    <v-list-item-subtitle class="mb-1">Email: {{customer.Email}}</v-list-item-subtitle>
                                    <v-list-item-subtitle class="mb-1">Điện thoại: {{`${customer.PhoneNumber}`}}</v-list-item-subtitle>
                                    <v-list-item-subtitle class="mb-1">Địa chỉ: {{customer.Address}}</v-list-item-subtitle>
                                </v-list-item-content>
                                </v-list-item>
                            </v-card>
                            <v-layout row wrap pt-2>
                                <v-flex lg12 sm12 :style="(!customerView || !showCustomerDetail) ? 'height: 300px' : 'height: 163px'">
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap pt-2>
                                <v-flex lg4 md4>
                                    <v-card-title class="pa-0 font-weight-bold text-red">Trạng thái</v-card-title>
                                </v-flex>
                                <v-flex lg8 sm8 pa-0>
                                    <v-select class="pa-0 font-weight-bold text-red" :items="orderStatus" v-model="payauthority.Status" item-text="name" item-value="value" disabled></v-select>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </div>
                </v-widget>
            </v-flex>
            <!-- Danh gia don hang -->
            <v-flex lg6>
                <v-widget title="Chat box">
                    <div slot="widget-content">
                        <message-box :orderId="modifyId" :orderType="6" :isInternal="payauthority.Type == 1"></message-box>
                    </div>
                </v-widget>
            </v-flex>
            
            <v-flex v-if="(payauthority.Status == orderStatusEnum.cho_uy_quyen || payauthority.Status == orderStatusEnum.cho_bao_gia) && adminRole" lg12>
                <v-widget title="Chọn tài khoản ủy quyền">
                    <div slot="widget-content">
                        <v-layout row wrap>
                            <v-flex lg4 sm12>
                                <v-select
                                    label="Tài khoản ủy quyền"
                                    :items="payAccounts"
                                    v-model="payauthority.AcceptPayAccount"
                                    item-text="name" item-value="value"
                                    :multiple="true"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-widget>
            </v-flex>

            <!-- Ma lenh -->
            <v-flex lg12>
                <v-widget title="Danh sách lệnh">
                    <div slot="widget-content">
                        <v-layout row wrap>
                            <v-flex lg11 sm12 pa-0 ma-0 pt-4>
                                <v-layout class="font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text>Tổng số lệnh cần thanh toán</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <v-text-field type="number" :disabled="!canEdit" v-model="payauthority.NumberDetail" label="Số lệnh"></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <authority-executes v-if="payauthority.Status != 2 || ((payauthority.Status == orderStatusEnum.cho_uy_quyen || payauthority.Status == orderStatusEnum.cho_bao_gia) && adminRole)" v-model="payauthority.OrderCodes" :orderStatus="payauthority.Status" :payAccounts="payAcceptAccounts" :canConfirm="canConfirm" :orderId="modifyId" :orderType="payauthority.Type" :locked="!canEdit"></authority-executes>
                    </div>
                </v-widget>
            </v-flex>

            <!-- Chi phi don hang -->
            <v-flex md12 lg12 sm12>
                <v-widget title="Chi tiết thanh toán hộ">
                    <div slot="widget-content">
                        <v-layout row wrap>
                            <v-flex lg11 sm12 pa-0 ma-0 pt-4>
                                <v-layout class="font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text></v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <v-checkbox label="Fix tỷ giá" v-model="payauthority.FixPrice" :disabled="!canEdit"></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text>Tỷ giá</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input :readonly="!canEdit" :disabled="!payauthority.FixPrice" v-model="payauthority.ExchangeRate" :decimal="0" label="₫"></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text>Số tiền cần thanh toán</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input :disabled="payauthority.Type != 1" v-model="payauthority.Amount" :decimal="2" label="¥"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input v-model="payauthority.AmountVND" :decimal="0" label="₫" disabled></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text>Phí thanh toán (đ)</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input :readonly="!canEdit" :disabled="!payauthority.FixPrice" v-model="payauthority.FeeVND" :decimal="0" label="đ"></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="payauthority.Refund" class="font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text>Số tiền hoàn lại (¥)</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <v-layout row wrap>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input disabled v-model="payauthority.Refund" :decimal="2" label="¥"></h-currency-input>
                                            </v-flex>
                                            <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                <h-currency-input :value="payauthority.Refund * payauthority.ExchangeRate" :decimal="0" label="đ" disabled></h-currency-input>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text>Tổng tiền</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <h-currency-input v-model="payauthority.TotalAmount" :decimal="0" label="đ" disabled></h-currency-input>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="payauthority.Dispute" class="font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text>Khiếu nại</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <v-text-field disabled v-model="payauthority.Dispute" label="Khiếu nại"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="font-weight-bold" row wrap>
                                    <v-flex lg3 sm3>
                                        <v-card-text>Ghi chú</v-card-text>
                                    </v-flex>
                                    <v-flex lg9 sm9>
                                        <v-text-field :disabled="!canEdit" v-model="payauthority.Content" label="Ghi chú"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-widget>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogRefund" max-width="800px">
            <v-card>
                <v-card-title>
                <span class="title">Hoàn tiền cho khách</span>
                </v-card-title>
                <v-card-text>
                <v-container grid-list-md pa-0>
                    <v-layout row wrap>
                        <v-flex lg12 md12 sm12>
                            <v-list v-if="payauthority.Status != orderStatusEnum.da_uy_quyen">
                                <v-list-item v-for="(item, index) in payauthority.OrderCodes" :key="item.ID">
                                    <v-list-item-content>
                                        <v-flex lg3 md3 sm12>
                                            <v-checkbox label="Hủy lệnh" :disabled="!!item.Cancelled" @change="onSelectRefundItem(item.ID, index)"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg3 md3 sm12>
                                            <h-currency-input disabled label="Giá trị(¥)" :decimal="2" v-model="item.Amount"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg3 md3 sm12>
                                            <v-text-field disabled label="Mã đơn hàng TQ" v-model="item.OrderCode"></v-text-field>
                                        </v-flex>
                                        <v-flex lg3 md3 sm12>
                                            <v-select disabled :items="payAccounts" label="Tài khoản UQ" v-model="item.PayID" item-text="name" item-value="value"></v-select>
                                        </v-flex>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-layout row wrap>
                                <v-divider class="ma-0"></v-divider>
                                <v-flex sm12>
                                    <h-currency-input label="Số tiền hoàn lại (¥)" :decimal="2" v-model="refundRequest.Refund"></h-currency-input>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1 white--text" @click="dialogRefund = false">Đóng</v-btn>
                <v-btn color="red darken-1 white--text" @click="processRefundOrder">Gửi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import VWidget from "@/components/VWidget";
import MessageBox from "@/components/chat/MessageBox";
import AuthorityExecutes from "@/components/widgets/AuthorityExecutes";
import configs from "@/configs";
import { sendErrorNotice } from "@/commons/utils";

export default {
    components: {
        VWidget,
        MessageBox,
        'authority-executes': AuthorityExecutes
    },
    data() {
        return {
            showCustomerDetail: false,
            orderStatus: configs.PAY_AUTHORITY_STATUS,
            orderStatusEnum: configs.PAY_AUTHORITY_STATUS_ENUM,
            dialogRefund: false,
            refundRequest: {
                Status: 5,
                cancelDetails: [],
                Refund: 0
            }
        }
    },
    computed: {
        ...mapState({
            loading: state => state.payauthority.loading,
            payauthority: state => state.payauthority.selected,
            customer: state => state.customer.selected,
            configuration: state => state.configuration.selected
        }),
        modifyId() {
            return Number(this.$route.params.Pid);
        },
        customerView() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager);
        },
        customerServiceRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        },
        adminRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.PayService) == configs.ROLE_TYPE.PayService);
        },
        canEdit() {
            const isAdmin = ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin);
            const isCSKH = ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
            const isTTQT = ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.PayService) == configs.ROLE_TYPE.PayService);
            if ((isAdmin || isTTQT) && this.payauthority.Status !== this.orderStatusEnum.hoan_thanh && this.payauthority.Status !== this.orderStatusEnum.da_uy_quyen) return true;
            if (isCSKH && this.payauthority.Type !== 1 && this.payauthority.Status == this.orderStatusEnum.cho_bao_gia) return true;
            if (isCSKH && this.payauthority.Type === 1 && (this.payauthority.Status == this.orderStatusEnum.cho_bao_gia || this.payauthority.Status == this.orderStatusEnum.cho_uy_quyen)) return true;
            return false;
        },
        canConfirm() {
            const isCSKH = (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
            if (this.payauthority && this.payauthority.Type == 1 && this.payauthority.Status == this.orderStatusEnum.cho_uy_quyen && isCSKH) {
                return true;
            }
            return false;
        },
        payAcceptAccounts() {
            if (this.payauthority && this.payauthority.Type == 1) {
                if (this.payauthority.Status !== this.orderStatusEnum.hoan_thanh && this.payauthority.Status !== this.orderStatusEnum.da_uy_quyen) {
                    const  acceptAcc = this.payauthority.AcceptPayAccount ? this.payauthority.AcceptPayAccount.map(i => String(i)) : [];
                    return this.payAccounts.filter(p => acceptAcc.indexOf(String(p.value)) !== -1).map(a => {
                        return {...a, name: a.name + '  ('+ (a.wallet ? a.wallet : 0) +'¥)'}
                    });
                } else {
                    if (this.configuration && this.configuration.AuthAccounts) {
                        return JSON.parse(this.configuration.AuthAccounts).map(a => {
                            return {...a, name: a.name + '  ('+ (a.wallet ? a.wallet : 0) +'¥)'}
                        });
                    }
                }
            }
            return this.payAccounts.map(a => {
                return {...a, name: a.name + '  ('+ (a.wallet ? a.wallet : 0) +'¥)'}
            });
        },
        payAccounts() {
            if (this.configuration && this.configuration.AuthAccounts) {
                const accList = JSON.parse(this.configuration.AuthAccounts);
                if (accList.length) {
                    console.log(this.payauthority.AcceptPayAccount)
                    if (this.payauthority.Status !== this.orderStatusEnum.hoan_thanh && this.payauthority.Status !== this.orderStatusEnum.da_uy_quyen) {
                        return accList.filter(a => a.active && Number(a.wallet) >= this.payauthority.Amount).map(a => {
                            return {...a, name: a.name + '  ('+ (a.wallet ? a.wallet : 0) +'¥)'}
                        });
                    }
                    return accList.map(a => {
                        return {...a, name: a.name + '  ('+ (a.wallet ? a.wallet : 0) +'¥)'}
                    });
                }
            }
            return [];
        },
        customStatus() {
            if (this.payauthority) {
                if (this.payauthority.Status == 2 && this.payauthority.Type == 1) {
                    return 'Chờ cấp TKUQ';
                } else {
                    const st = configs.PAY_AUTHORITY_STATUS.find(s => s.value == this.payauthority.Status);
                    if (st) return st.name;
                }
            }
            return '';
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        },
        payauthority() {
            if(this.payauthority) {
                this.$store.dispatch("customer/getCustomerDetail", this.payauthority.UID);
            }
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("payauthority/getDetail", this.modifyId);
            } else {
                window.getApp.$emit("APP_NAVIGATE", "PayAuthorityList");
            }
        },
        onSelectRefundItem(ID) {
            const index = this.refundRequest.cancelDetails.indexOf(ID);
            if (index !== -1) {
                this.refundRequest.cancelDetails.splice(index, 1);
            } else {
                this.refundRequest.cancelDetails.push(ID);
            }
        },
        saveRefund() {
            this.dialogRefund = true;
        }, 
        processRefundOrder() {
            if (!this.refundRequest.cancelDetails.length && this.payauthority.Status == this.orderStatusEnum.khieu_nai) {
                sendErrorNotice("Chọn tối thiểu 1 lệnh hủy!");
                return;
            }
            if (this.refundRequest.Refund > this.payauthority.Amount) {
                sendErrorNotice("Số tiền hoàn lớn hơn số tiền yêu cầu ủy quyền!");
                return;
            }
            if (this.payauthority.Status != this.orderStatusEnum.khieu_nai) {
                this.refundRequest.Status = this.orderStatusEnum.don_huy;
            }
            this.$store.dispatch("payauthority/setDetail", {
                data: this.refundRequest,
                id: this.payauthority.ID
            });
            this.dialogRefund = false;
        },
        saveData() {
            if (this.payauthority.NumberDetail &&  ((Number(this.payauthority.NumberDetail) * 10) % 10 != 0 ||  Number(this.payauthority.NumberDetail) <= 0)) {
                sendErrorNotice("Số lệnh phải là số nguyên dương");
                return;
            }
            
            if (this.payauthority.Status !== this.orderStatusEnum.cho_bao_gia && this.payauthority.Status !== this.orderStatusEnum.cho_uy_quyen) {
                if(!this.payauthority.OrderCodes || !this.payauthority.OrderCodes.length || !this.payauthority.OrderCodes.filter(i => i.Amount && i.OrderCode && i.PayID).length) {
                    sendErrorNotice("Ủy quyền thanh toán phải có ít nhất 1 lệnh hợp lệ gồm giá, mã đơn, tài khoản ủy quyền!");
                    return;
                }
                if (this.payauthority.OrderCodes.length != Number(this.payauthority.NumberDetail)) {
                    sendErrorNotice("Số lệnh tạo chưa khớp với tổng lệnh khai báo!");
                    return;
                }
            }
            if(this.payauthority.Type == 0 && !this.payauthority.ExchangeRate) {
                sendErrorNotice("Chưa nhập tỷ giá!");
                return;
            }
            if(!this.payauthority.Amount) {
                sendErrorNotice("Chưa nhập tiền lệnh thanh toán!");
                return;
            }
            const amountTotal = this.payauthority.OrderCodes.map(o => o.Amount).reduce((a, b) => a + b, 0);
            if (this.payauthority.Status !== this.orderStatusEnum.cho_bao_gia && this.payauthority.Status !== this.orderStatusEnum.cho_uy_quyen && amountTotal !== this.payauthority.Amount) {
                sendErrorNotice("Tổng giá trị lệnh phải bằng tổng giá trị mỗi đơn!");
                return;
            }
            let data = {...this.payauthority};
            if (this.payauthority.AcceptPayAccount) {
                data.AcceptPayAccount = this.payauthority.AcceptPayAccount.join(',');
            }
            this.$store.dispatch("payauthority/setDetail", {
                data,
                id: this.payauthority.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "PayAuthorityList");
        },
        waitAuthority() {
            if(!this.payauthority.AcceptPayAccount) {
                sendErrorNotice("Tài khoản ủy quyền chưa được chọn!");
                return;
            }
            if(!this.payauthority.ExchangeRate) {
                sendErrorNotice("Chưa nhập tỷ giá!");
                return;
            }
            if (this.payauthority.NumberDetail &&  ((Number(this.payauthority.NumberDetail) * 10) % 10 != 0 ||  Number(this.payauthority.NumberDetail) <= 0)) {
                sendErrorNotice("Số lệnh phải là số nguyên dương");
                return;
            }
            this.payauthority.Fee = this.payauthority.Fee ? this.payauthority.Fee : 0;

            const data = {
                Status: this.orderStatusEnum.cho_uy_quyen,
                AcceptPayAccount: this.payauthority.AcceptPayAccount.join(','),
                ExchangeRate: this.payauthority.ExchangeRate,
                AmountVND: this.payauthority.ExchangeRate * this.payauthority.Amount,
                Fee: this.payauthority.ExchangeRate ? this.payauthority.FeeVND / this.payauthority.ExchangeRate : 0,
                FeeVND: this.payauthority.FeeVND,
                TotalAmount: (this.payauthority.ExchangeRate * this.payauthority.Amount) + (this.payauthority.ExchangeRate * this.payauthority.Fee),
                Content: this.payauthority.Content,
                NumberDetail: this.payauthority.NumberDetail,
            };

            if (this.payauthority.Type === 1) {
                data.OrderCodes = this.payauthority.OrderCodes;
            }

            this.$store.dispatch("payauthority/setDetail", {
                data,
                id: this.payauthority.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "PayAuthorityList");
        },
        completeOrder() {
            this.$store.dispatch("payauthority/setDetail", {
                data: {
                    Status: this.orderStatusEnum.hoan_thanh
                },
                id: this.payauthority.ID
            });
        },
        cancelOrder() {
            let Status = this.orderStatusEnum.don_huy;
            this.$store.dispatch("payauthority/setDetail", {
                data: {
                    Status
                },
                id: this.payauthority.ID
            });
        },
        confirmPayment() {
            const unpay = this.payauthority.OrderCodes.filter(o => !o.PayID);
            if (unpay.length) {
                sendErrorNotice("Tài khoản ủy quyền trong các lệnh chưa được chọn!");
                return;
            }
            const unlink = this.payauthority.OrderCodes.filter(o => !o.LinkPay);
            if (unlink.length) {
                sendErrorNotice("Link thanh toán trong các lệnh chưa được chọn!");
                return;
            }
            this.payauthority.Status = this.orderStatusEnum.da_uy_quyen;
            this.$store.dispatch("payauthority/setDetail", {
                data: this.payauthority,
                id: this.payauthority.ID
            });
        }
    },
    mounted() {
        this.refreshData();
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.payauthority.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
